import { ECOMMERCE_PAGE_COUNT_CONTROL_NAME } from 'editor/src/store/variants/constants';

import { RootState } from 'editor/src/store';

import getECommerceProduct from './getECommerceProduct';

// The valid page counts an ecommerce product can switch to, ascending. These
// come from the "Page count" control's variants and define the real grid the
// design must land on (adding/removing pages must hit one of these exactly,
// see changeEcommerceVariantPageCountOperation). Returns undefined when the
// product is not an ecommerce product or has no page-count control.
function getECommercePageCounts(state: RootState): number[] | undefined {
  const ecommerceProduct = getECommerceProduct(state);
  if (!ecommerceProduct) {
    return undefined;
  }

  const pageCountControlIndex = ecommerceProduct.options.findIndex(
    (option) => option.name === ECOMMERCE_PAGE_COUNT_CONTROL_NAME,
  );
  if (pageCountControlIndex === -1) {
    return undefined;
  }

  return ecommerceProduct.variants
    .map((variant) => parseInt(variant.optionValues[pageCountControlIndex], 10))
    .filter((pageCount) => !Number.isNaN(pageCount))
    .sort((a, b) => a - b);
}

export default getECommercePageCounts;
